export const CONTACT = {
  brand: "Vaucopin",
  fullName: "SAS Vaucopin",
  phone: "+33 (0)6 42 42 42 07",
  phoneHref: "tel:+33642424207",
  email: "reservation@vaucopin.com",
  privacy: "privacy@vaucopin.com",
  address: "1850 Route du Haut Bréda, Le Pleynet, 38580 Le Haut-Bréda",
  siren: "914 124 011",
  capital: "10 000 €",
  director: "Jean-Philippe Vacher",
  resort: "Les 7 Laux — Le Pleynet",
};

export const IMAGES = {
  hero: "/images/montagne.webp",
  manifesto: "https://images.unsplash.com/photo-1743179231432-6884c3e092e9?crop=entropy&cs=srgb&fm=jpg&ixid=M3w3NTY2Nzd8MHwxfHNlYXJjaHw0fHxmcmVuY2glMjBhbHBzJTIwc25vdyUyMG1vdW50YWluc3xlbnwwfHx8fDE3ODgxOTUxMjZ8MA&ixlib=rb-4.1.0&q=85",
};

export const STUDIOS = [
  {
    slug: "glaciers",
    numeral: "01",
    name: "Studio des Ô Glaciers",
    short: "Ô Glaciers",
    tagline: "Face aux sommets, baigné de lumière",
    description:
      "Orienté plein sud, le Studio des Ô Glaciers ouvre sur un panorama exceptionnel de la chaîne de Belledonne. Son séjour tout de bois clair et sa kitchenette entièrement équipée composent un refuge douillet après une journée sur les pistes des 7 Laux. Le soir venu, la grande table familiale accueille les dîners savoyards dans une atmosphère chaleureuse.",
    image: "/images/glaciers-sejour.webp",
    airbnb: "https://fr.airbnb.ch/rooms/807219379997999156",
    surface: "28 m²",
    capacity: "2 à 4 personnes",
    floor: "5e étage avec ascenseur",
    orientation: "Plein sud, vue sur la chaîne de Belledonne",
    amenities: [
      "Kitchenette équipée (plaque, micro-ondes, réfrigérateur, lave-vaisselles, toaster, appareil à raclette / gaufre / fondue, bouilloire, machine à café)",
      "Coin repas familial avec grande table",
      "Couchages : canapé convertible + couchages d'appoint",
      "TV écran plat",
      "Casier à skis privatif au pied des pistes",
      "Parking gratuit",
    ],
    gallery: [
      { src: "/images/glaciers-sejour.webp", alt: "Séjour du Studio des Ô Glaciers avec table dressée et mur en bois" },
      { src: "/images/glaciers-cuisine.webp", alt: "Kitchenette équipée du Studio des Ô Glaciers" },
      { src: "/images/montagne.webp", alt: "Vue sur la chaîne de Belledonne enneigée depuis le studio" },
    ],
    pricing: [
      { season: "Haute saison (vacances scolaires d'hiver)", week: "700 €", weekend: "250 €" },
      { season: "Moyenne saison", week: "450 €", weekend: "200 €" },
      { season: "Basse saison / été", week: "400 €", weekend: "200 €" },
    ],
  },
  {
    slug: "gentianes",
    numeral: "02",
    name: "Studio des Ô Gentianes",
    short: "Ô Gentianes",
    tagline: "L'esprit chalet, au cœur de la station",
    description:
      "Le Studio des Ô Gentianes cultive l'esprit chalet authentique : mobilier de caractère, touches de couleur inspirées des gentianes alpines et une fenêtre ouverte sur les sapins et les crêtes. Idéalement placé au cœur du Pleynet, il permet de chausser les skis au pied de la résidence et de rejoindre commerces et restaurants en quelques pas.",
    image: "/images/gentianes-sejour.webp",
    airbnb: "https://www.airbnb.fr/rooms/1358585500696688932",
    surface: "26 m²",
    capacity: "2 à 4 personnes",
    floor: "1er étage avec ascenseur",
    orientation: "Vue sur la forêt et les sommets",
    amenities: [
      "Coin repas convivial pour 4 personnes",
      "Kitchenette équipée (plaque, micro-ondes, réfrigérateur, lave-vaisselles, toaster, appareil à raclette / gaufre / fondue, bouilloire, machine à café)",
      "Couchages : canapé-lit + coin montagne",
      "TV écran plat",
      "Casier à skis privatif au pied des pistes",
      "Parking gratuit",
    ],
    gallery: [
      { src: "/images/gentianes-sejour.webp", alt: "Coin repas du Studio des Ô Gentianes avec skis anciens en décoration" },
      { src: "/images/gentianes-vue.webp", alt: "Vue sur les sapins et les crêtes depuis la fenêtre du Studio des Ô Gentianes" },
      { src: "/images/montagne.webp", alt: "Paysage enneigé de la station Les 7 Laux Le Pleynet" },
    ],
    pricing: [
      { season: "Haute saison (vacances scolaires d'hiver)", week: "700 €", weekend: "250 €" },
      { season: "Moyenne saison", week: "450 €", weekend: "200 €" },
      { season: "Basse saison / été", week: "400 €", weekend: "200 €" },
    ],
  },
];

export const REVIEWS = [
  {
    name: "Famille Marchand",
    location: "Lyon",
    date: "Février 2026",
    rating: 5,
    text: "Un séjour inoubliable au Studio des Ô Glaciers. La vue au réveil est tout simplement magique, et le studio est impeccablement équipé. Départ skis aux pieds, un vrai luxe avec des enfants.",
  },
  {
    name: "Sophie & Julien R.",
    location: "Grenoble",
    date: "Janvier 2026",
    rating: 5,
    text: "L'esprit chalet du Studio des Ô Gentianes nous a séduits dès l'entrée. Accueil chaleureux, propreté irréprochable et une station familiale que nous ne connaissions pas. Nous reviendrons.",
  },
  {
    name: "Marc D.",
    location: "Paris",
    date: "Mars 2026",
    rating: 5,
    text: "Réservation simple et échanges très réactifs avec les propriétaires. Le domaine des 7 Laux est superbe et le rapport qualité-prix de ces studios est rare pour un emplacement pareil.",
  },
  {
    name: "Élodie B.",
    location: "Annecy",
    date: "Août 2025",
    rating: 4,
    text: "Nous avons découvert le Pleynet en été : randonnées magnifiques au départ de la résidence et un calme absolu. Le studio est confortable et la vue sur les crêtes un vrai bonheur en fin de journée.",
  },
];

export const MARQUEE_ITEMS = [
  "Ski aux pieds",
  "Vue panoramique sur Belledonne",
  "Exposition plein sud",
  "Station familiale des 7 Laux",
  "135 km de pistes",
  "Été : randonnées & lacs d'altitude",
];
